import { render, staticRenderFns } from "./notificationPreferences.vue?vue&type=template&id=7f5d96ff&scoped=true"
import script from "./notificationPreferences.vue?vue&type=script&lang=js"
export * from "./notificationPreferences.vue?vue&type=script&lang=js"
import style0 from "./notificationPreferences.vue?vue&type=style&index=0&id=7f5d96ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5d96ff",
  null
  
)

export default component.exports